import { BRAND_PROFILES } from "@/lib/brandProfile";
import { ChevronDown } from "lucide-react";

export function SplashHero({ onScrollDown }) {
  // Public hero — always default brand.
  const brand = BRAND_PROFILES.default;
  return (
    <section className="relative min-h-screen w-full bg-black overflow-hidden flex items-center justify-center grain" data-testid="splash-hero">
      {/* Ambient backdrop glows */}
      <div className="absolute -top-40 -right-40 w-[36rem] h-[36rem] rounded-full bg-primary/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-40 w-[36rem] h-[36rem] rounded-full bg-red-600/10 blur-3xl pointer-events-none" />

      <div className="relative z-10 px-6 py-12 pb-32 flex flex-col items-center text-center max-w-3xl">
        {/* Logo */}
        <div className="w-[22rem] sm:w-[28rem] md:w-[34rem] lg:w-[38rem] aspect-square mx-auto rounded-2xl overflow-hidden bg-black ring-1 ring-white/10 shadow-2xl flex items-center justify-center">
          {brand.key === "default" ? (
            <img
              src="/brand/ssp_hero_square.jpg"
              alt="ServiceSell Pro"
              className="w-full h-full object-contain"
              data-testid="splash-logo"
            />
          ) : brand.logoUrl ? (
            <img
              src={brand.logoUrl}
              alt={brand.dealerName}
              className="w-3/4 h-3/4 object-contain"
              data-testid="splash-logo"
            />
          ) : (
            <div className="flex flex-col items-center justify-center text-center px-8" data-testid="splash-logo">
              <div
                className="font-display font-black tracking-tight text-7xl sm:text-8xl md:text-9xl leading-none"
                style={{ color: brand.logoTextColor }}
              >
                {brand.logoText || brand.wordmark}
              </div>
              <div className="mt-6 text-xs sm:text-sm uppercase tracking-[0.4em] text-white/55">
                Smart Service
              </div>
              <div className="mt-12 text-[10px] uppercase tracking-[0.35em] text-white/30">
                Powered by ServiceSell PRO&trade;
              </div>
            </div>
          )}
        </div>

        <div className="mt-8 text-[11px] font-bold uppercase tracking-[0.4em] text-primary">
          Inspect · Advise · Sell · Grow
        </div>
        <h1 className="mt-3 font-display font-black tracking-tighter text-3xl sm:text-4xl text-white">
          More transparency. More trust. <span className="text-primary">More sales.</span>
        </h1>
        <p className="mt-5 max-w-xl text-white/65 text-base sm:text-lg leading-relaxed" data-testid="splash-tagline">
          The commercial operating system for modern aftersales departments.
        </p>
      </div>

      {/* Scroll hint — anchored to the bottom of the viewport. With the
          engine-start button removed, this becomes the primary action:
          a quiet, enterprise-grade cue to scroll into the detail. */}
      <button
        onClick={onScrollDown}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/50 hover:text-white/90 transition-colors flex flex-col items-center gap-1 group"
        data-testid="scroll-down-btn"
      >
        <span className="text-[10px] font-bold uppercase tracking-[0.3em]">Learn more</span>
        <ChevronDown className="w-5 h-5 animate-bounce" />
      </button>
    </section>
  );
}
